<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-page p-3 customer-listing">
            <b-card-header class="assets-filter">
                <b-row class="mt-2">
                    <!-- <b-col cols="3" lg="1" class="d-flex align-items-center justify-content-center"><strong>{{ title
                    }}</strong></b-col> -->
                    <b-col cols="12" class="search-field">
                        <!-- <div class="input-group">
                            <b-form-input type="text" :placeholder="$translate('search_filter')"
                                addon-right-icon="ni ni-zoom-split-in" v-model="query"></b-form-input>
                            <div class="input-group-prepend bg-transparent">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </div> -->
                        <div class="input-group p-0">
                            <b-input-group class="p-0 mb-0">
                                <b-form-input class="form-control" id="search-customer-name-input" type="text" :placeholder="$translate('search_with_customer_name')"
                                    v-model="query"></b-form-input>
                                <template #prepend>
                                    <div class="d-flex">
                                        <div class="querySelect dd w-100">
                                            <b-form-select class="form-control w-100 h-100" id="input-1"
                                                v-model="filters.queryOptionsValue" :options="queryOptions"
                                                value-field="value" text-field="name" block />
                                                                </div>
                                        <!-- <div class="vr bg-dark m-1"></div> -->
                                    </div>
                                </template>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="12" md="6">
                        <div class="d-flex">
                            <b-button id="toggle-filter-btn" variant="blue-button" v-if="hasPermissionView" class="me-2"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button id="reset-filter-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col>
                </b-row>
                <customer-query-builder v-show="toggle_filters" v-model="filters" :lifecycleStages="lifecycleStages"
                    :customerAgents="customerAgents" :customerGroups="customerGroups"
                    :customerSegments="customerSegments" />
            </b-card-header>

            <b-card-body class="p-2">
                <b-col class="page-block"><strong>{{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{
                    pageCount }} {{ $translate('total') }}:
                        {{ pagination.total }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table id="customerTable" :items="customers" :fields="fields" small responsive>
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-customer-details-'+row.item.id" @click="viewCustomer(row.item.id)" variant="pink-button" class="mr-2"
                                v-if="hasPermissionView">
                                <img src="@/assets/images/icon/view.svg" alt="view" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>

                <b-row>
                    <b-col>
                        <b-pagination class="float-right mt-4" v-model="pagination.page" :total-rows="pagination.total"
                            :per-page="pagination.pageSize" :next-text="$translate('next')"
                            :prev-text="$translate('previous')" aria-controls="customerTable" pills
                            align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import CustomerQueryBuilder from './CustomerQueryBuilder'
import permissionsMixins from '@/mixins/permissionsMixins'

//import autoTable from 'jspdf-autotable'
export default {
    name: 'customers-table',
    components: { CustomerQueryBuilder },
    mixins: [popupMixins, permissionsMixins],
    props: [
        'type',
        'title',
        'lifecycleStages',
        'customerSegments',
        'customerGroups',
        'customerAgents',
    ],
    data() {
        return {
            queryOptions: [
                { value: 'contains', name: this.$translate('contains') },
                { value: 'starts_with', name: this.$translate('starts_with') },
                { value: 'ends_with', name: this.$translate('ends_with') },
            ],
            query: '',
            toggle_filters: false,
            filters: {
                queryOptionsValue: 'starts_with',
                customer_agent_id: null,
                customer_segment_id: null,
                lifecycle_stage_id: null,
                customer_group_id: null,
            },
            template: false,
            tableLoading: false,
            page: 1,
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        if(this.$store.state.customers.filters) {
            for(const key in this.$store.state.customers.filters){
                const value = this.$store.state.customers.filters[key];
                this.$set(this.filters, key, value)
            }
        }
        if(this.$store.state.customers.query != '') this.query = this.$store.state.customers.query
        this.doSearch()
    },
    watch: {
        customers: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            if (this.page != newPage) {
                this.changePage(newPage)
            }
            this.page = newPage
        },
        filters: {
            handler: function () {
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        // queryOptionsValue: _.debounce(function (queryOptionsValue) {
        //     this.doSearch()
        // }, 200),

    },
    methods: {
        resetFilters() {
            this.filters = {
                customer_agent_id: null,
                queryOptionsValue: 'starts_with',
                customer_segment_id: null,
                customer_group_id: null,
                lifecycle_stage_id: null,
            }
            this.doSearch()
        },

        getReportQuery() {
            const q = this.query
            const x = {
                q,
                ...this.filters,
            }

            console.log('report query:', x)
            return x
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.tableLoading = true
                const {
                    query,
                    filters,
                    pagination: { page = 1 },
                } = this
                console.log('filters', filters)
                this.$router.push({
                    query: { page, query, ...filters },
                });
                await this.$store.dispatch('customers/fetch', {
                    query,
                    filters,
                    page,
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        viewCustomer(id) {
            id = parseInt(id) || 0
            this.$router.push({ params: { id }, name: 'viewCustomer' })

            // this.$store.dispatch('customerSegments/fetchAll')
            // this.$store.dispatch('customerGroups/fetchAll')
            // this.$store.dispatch('customerAgents/fetchAll')
            // this.$store.dispatch('additionalField/fetchAll', { module_for: 2 })
        },
        deleteItem(id) {
            let item = this.customers.find(el => el.id == id)

            const title = this.$translate('delete_customer_note')
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('customers/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('customer_delete'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        fields() {
            return [
                { label: this.$translate('actions'), key: 'id' },
                { label: this.$translate('code'), key: 'code' },
                { label: this.$translate('name'), key: 'name' },
                { label: this.$translate('phone'), key: 'phone' },
                {
                    key: 'work_number',
                    label: this.$translate('work_number'),
                },
                {
                    key: 'customer_agent_id',
                    label: this.$translate('customer_agent'),
                    formatter: (value, key, item) =>
                        item.customer_agent && item.customer_agent.agent_name
                            ? item.customer_agent.agent_name
                            : '',
                },
                {
                    key: 'customer_segment_id',
                    label: this.$translate('customer_segment'),
                    formatter: (value, key, item) =>
                        item.customer_segment && item.customer_segment.name
                            ? item.customer_segment.name
                            : '',
                },
                {
                    key: 'customer_group_id',
                    label: this.$translate('customer_group'),
                    formatter: (value, key, item) =>
                        item.customer_group && item.customer_group.name
                            ? item.customer_group.name
                            : '',
                },
                {
                    key: 'lifecycle_stage_id',
                    label: this.$translate('lifecycle_stage'),
                    formatter: (value, key, item) =>
                        item.lifecycle_stage && item.lifecycle_stage.name
                            ? item.lifecycle_stage.name
                            : '',
                },
                { label: this.$translate('email'), key: 'email' },
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        customers() {
            return this.$store.getters['customers/customers']
        },
        pagination() {
            return this.$store.state.customers.pagination || {}
        },
        user() {
            return this.$store.state.user
        },
    },
}
</script>
<style></style>
